export enum MetaType {
    Robots = "robots",
    Author = "author",
    Keywords = "keywords",
    Date = "date",
    Description = "description",
    Copyright = "copyright",
    ReplyTo = "reply-to"
}
